import { Component, Input, HostBinding } from '@angular/core';

@Component({
  selector: 'heading-title',
  templateUrl: './heading-title.component.html',
  styleUrls: ['./heading-title.component.scss']
})
export class HeadingTitleComponent {
}
